import { render } from "./AccountGroup.vue?vue&type=template&id=1c7e0e5f&scoped=true"
import script from "./AccountGroup.vue?vue&type=script&lang=js"
export * from "./AccountGroup.vue?vue&type=script&lang=js"

import "./AccountGroup.vue?vue&type=style&index=0&id=1c7e0e5f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7e0e5f"]])

export default __exports__